<div ngClass.xs="xs">
  <h2 matDialogTitle>Znajdź lepszą ofertę</h2>

  <div fxLayout="column" fxLayoutAlign="start stretch" class="pt-12">
    <div class="swiper-container" >
<!--      [swiper]="config"-->
<!--      swiper todo-->
      <div class="swiper-wrapper wrapper-margin">
        <div class="swiper-slide" fxFlex fxLayout="column" fxLayoutAlign="start center">
          <img src="../../../../assets/images/undraw/trypay/xsell_loupe.svg" />
          <div class="italic mt-32">Wyszukujemy i porównujemy najlepsze oferty na rynku</div>
        </div>

        <div class="swiper-slide" fxFlex fxLayout="column" fxLayoutAlign="start center">
          <img src="../../../../assets/images/undraw/trypay/xsell_board.svg" />
          <div class="italic mt-32">Wybieramy ofertę najbardziej dopasowaną do Twoich potrzeb</div>
        </div>

        <div class="swiper-slide" fxFlex fxLayout="column" fxLayoutAlign="start center">
          <img src="../../../../assets/images/undraw/trypay/xsell_charts.svg" />
          <div class="italic mt-32">Przedstawiamy Ci nową, specjalnie przygotowaną ofertę</div>
        </div>

        <div class="swiper-slide" fxFlex fxLayout="column" fxLayoutAlign="start center">
          <img src="../../../../assets/images/undraw/trypay/xsell_conversation.svg" />
          <div class="italic mt-32">Decydujesz, czy chcesz, aby dostawca się z Tobą skontaktował</div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev" [fxHide]="handsetService.isXs" fxShow>
        <app-icon name="keyboard_arrow_left"></app-icon>
      </div>
      <div class="swiper-button-next" [fxHide]="handsetService.isXs" fxShow>
        <app-icon name="keyboard_arrow_right"></app-icon>
      </div>
    </div>

    <p class="mt-32">
      Czy wyrażasz zgodę na wykorzystanie danych z systemu dostawcy
      <strong>{{ customerBiller.biller.name }}</strong
      >, w&nbsp;celu przedstawienia Ci nowej, dedykowanej dla Ciebie oferty?
    </p>

    <mat-dialog-actions align="start">
      <button (click)="accept()" [matDialogClose]="true" color="primary" mat-raised-button type="submit">
        Zgadzam się
      </button>
      <button mat-button [matDialogClose]="false" type="button">Nie zgadzam się</button>
    </mat-dialog-actions>
  </div>
</div>
